<template>
  <div class="sitebuilder-element-container is-receiver"
       element="BoxHoverComponent"
       ref="elem"
       :id="id"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)"
       :key="componentKey"
       :style="style()"
       @contextmenu.prevent="handler($event)"
       @click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)"
                             v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" ref="draggableResizable"
                             :draggable="false" :enable-native-drag="true">

      <sync-drag :target="this"/>

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-BoxHoverComponent'>
        <template v-slot:before>
          <!--  Normal  -->
          <div class="custom-option-group" :class="{ 'active' : tabActive === 'normal'}" @click="changeTab('normal')">
            <img src="/static/images/icons/box-hover.svg"
                 :alt="$t('ct-box-hover-normal')"
                 v-tooltip="{content: $t('ct-box-hover-normal'),  class: 'tooltip-custom'}"
                 class="svg-icon custom-option-btn"/>
            <span class="custom-text" v-if="device === 'desktop'">{{ $t('ct-box-hover-normal') }}</span>
          </div>

          <!--  Hover  -->
          <div class="custom-option-group" :class="{ 'active' : tabActive === 'hover'}" @click.prevent="changeTab('hover')">
            <img src="/static/images/icons/box-hover-edit.svg"
                 :alt=" $t('ct-box-hover-edit')"
                 v-tooltip="{content: $t('ct-box-hover-edit'),  class: 'tooltip-custom'}"
                 class="svg-icon custom-option-btn"/>
            <span class="custom-text" v-if="device === 'desktop'">{{ $t('ct-box-hover-edit') }}</span>
          </div>

          <!--  Visualização  -->
          <div class="custom-option-group" :class="{ 'active' : tabActive === 'hoveing'}" @click.prevent="activeHover()" v-if="device === 'desktop'">
            <img src="/static/images/icons/box-hover-view.svg"
                 :alt="$t('ct-box-hover-view')"
                 v-tooltip="{content: $t('ct-box-hover-view'),  class: 'tooltip-custom'}"
                 class="svg-icon custom-option-btn"/>
            <span class="custom-text">{{ $t('ct-box-hover-view') }}</span>
          </div>
          <div class="vr"></div>
        </template>
      </options-element-bar>

      <template v-if="tabActive === 'normal'">
        <div class="box-hover-wrapper box-hover-circle left_to_right scale_up" :class="`effect${internal_config.effect}`" ref="box-hover">
          <div href="#" class="box-hover-content">
            <div class="box-hover-content-img"  v-bind:style="styleBoxContainer('cover')"></div>
          </div>
        </div>
      </template>

        <div v-show="tabActive === 'hover'" v-bind:style="styleBoxContainer('hover')"
             class="sitebuilder-element-receiver is-box-hover-component"
             ref="box-hover-edit">
          <component v-for="(element,index) in elements" :is="element.name" :config="element.config" :key="index"
                     :id="element.id" :height_start="index" :preview="preview" :childs="element.childs"
                     @setCallbackChangeDevice="setCallbackChangeDevice"></component>
        </div>

      <div v-if="tabActive === 'hoveing'"
           class="box-hover-wrapper box-hover-circle"
           :class="`effect${internal_config.effect} ${internal_config.direction}`" :key="keyChangePreview">
        <div href="#" class="box-hover-content box-hover-content-action">
          <div class="box-hover-content-img"  v-bind:style="styleBoxContainer('cover')"></div>
          <template v-if="internal_config.effect === '20'">
            <div class="box-hover-content-info" ref="box-hover-view" v-bind:style="styleBoxContent">
              <div class="info-back">
                <component v-for="(element,index) in preview_elements"
                           :is="element.name"
                           :config="element.config"
                           :key="index"
                           :id="`${element.id}-preview`"
                           :height_start="index"
                           :preview="preview"
                           :childs="element.childs"
                           @setCallbackChangeDevice="setCallbackChangeDevice"></component>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="box-hover-content-info" ref="box-hover-view" v-bind:style="styleBoxContent">
              <component v-for="(element,index) in preview_elements"
                         :is="element.name"
                         :config="element.config"
                         :key="index"
                         :id="`${element.id}-preview`"
                         :height_start="index"
                         :preview="preview"
                         :childs="element.childs"
                         @setCallbackChangeDevice="setCallbackChangeDevice"></component>
            </div>
          </template>
        </div>
      </div>
    </vue-draggable-resizable>
  </div>
</template>
<script>

import Model from './Model';
import OptionsElementBar from '../OptionsElementBar';

export default {
  name: 'BoxHoverComponent',
  components: {
    OptionsElementBar,
    Model
  },
  props: ['config', 'childs', 'height_start', 'device', 'id', 'preview'],
  data() {
    return Model.data();
  },
  computed: {

    boxShadow() {
      return this.internal_config.boxShadow;
    },
    radius() {
      return this.internal_config.borderRadius;
    },

    styleBoxContent() {
      return {
        'border-radius': this.radius,
        background: this.background('hover'),
        height : this.height(),
        minHeight : this.minHeight(),
        width : this.width(),
        border : this.border(),
        'box-shadow': this.boxShadow,
        'pointer-events': 'none'
      }
    }

  },
  methods: {
    styleBoxContainer(type) {

      var style =  {
        'border-radius': this.radius,
        background: this.background(type),
        height : this.height(),
        minHeight : this.minHeight(),
        width : '100%',
        border : this.border(),
        'box-shadow': this.boxShadow,
      };

      var heights = {
        height : 'auto',
        minHeight : this.minHeight(),
      }

      return this.device !== 'desktop' ? {...style, ...heights} : style;
    },

    changeTab(value) {
      this.tabActive = value;

      if (this.tabActive === 'normal') {
      }
    },

    activeHover() {
      this.tabActive = 'hoveing';

      let childsHub = JSON.parse(JSON.stringify(this.$eventHub.getChilds(this.id)));

      this.$data.preview_elements = [];
      this.$nextTick(() => {
        this.$data.preview_elements = childsHub.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
      });
    },

    background(type = 'cover') {
      let bg = this.internal_config[type].backgroundColor;

      if (this.internal_config[type].backgroundImage !== 'none' && typeof this.internal_config[type].backgroundImage !== 'undefined') {

        bg += ' url("' + this.internal_config[type].backgroundImage + '")';
        bg += ' ' + this.internal_config[type].backgroundPosition;
        bg += ' / ' + this.internal_config[type].backgroundSize;
        bg += ' ' + this.internal_config[type].backgroundRepeat;
        bg += ' ' + this.internal_config[type].backgroundOrigin;
      }
      return bg;
    },

    border() {
      return this.internal_config.border;
    },

    width() {
      return this.internal_config.width;
    },

    height() {
      return this.internal_config.height;
    },

    minHeight() {
      return this.internal_config.minHeight;
    },

    animation() {
      return false;
    },

    onResize: function (x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';
    },

    focusElement(e) {
      this.$root.$emit('focusElement', this);

      e.stopPropagation();
      e.preventDefault();
    },

    showResources() {
      // return this.$refs.resourcesData.getValuesData();
    },

    changeOrderPanel(elem, idx) {
      let id = elem.$el.id;
      let sibling = idx === 1 ? document.getElementById(id).nextSibling : document.getElementById(id).previousSibling;

      if (sibling === null) {
        return true;
      }

      this.$root.$emit('changeOrderElementsInside', this.id, id, sibling.id, idx);
    },

    handler: function (e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },

    style() {
      let style = `left:  ${this.internal_config.left};
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
      return style;
    },

    setCallbackChangeDevice(values) {
      this.$emit('setCallbackChangeDevice', values);
    },

    build(config) {
      let vm = this;
      vm.internal_config = _.merge(vm.internal_config, config);
      vm.keyChange++;
      vm.$forceUpdate();

      vm.$eventHub.setValueElementConfig(vm.id, vm.internal_config);
    },
    sendNewChilds() {
      let vm = this;

      setTimeout(() => {
        vm.$eventPointer.changePointerState(true);
        vm.$eventPointer.logChilds(vm.id, vm.elements);
        setTimeout(() => {
          vm.$eventPointer.changePointerState(true);
        }, 500);
      }, 500);
    },

    setChildsObj() {
      this.$eventPointer.logChilds(this.id, this.elements);

      let childsHub = this.$eventHub.getChilds(this.id);

      this.config.childs = childsHub;
      this.internal_config.childs = childsHub;

      this.elements = {};
      this.$nextTick(() => {
        this.elements = childsHub.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
        this.componentKey += 1;

        this.$nextTick(() => {
          this.sendNewChilds();
          this.$root.$emit('activeSort');
        });
      });
    },

    fixObjBackground(config) {
      var newConfig = JSON.parse(JSON.stringify(config));

      if(typeof config.src !== 'undefined') {
        newConfig.cover.backgroundImage = config.src;
      }

      if(typeof config['backgroundImage'] !== 'undefined') {
        newConfig.hover = {
          'backgroundColor': config['backgroundColor'],
          'backgroundImage': config['backgroundImage'],
          'backgroundPosition': config['backgroundPosition'],
          'backgroundOrigin':  config['backgroundOrigin'],
          'backgroundRepeat':  config['backgroundRepeat'],
          'backgroundSize':  config['backgroundSize'],
        };
      }

      delete newConfig.src
      delete newConfig['background-color']
      delete newConfig.backgroundColor
      delete newConfig.backgroundImage
      delete newConfig.backgroundPosition
      delete newConfig.backgroundOrigin
      delete newConfig.backgroundRepeat
      delete newConfig.backgroundSize

      return newConfig;
    }
  },

  created() {
    let device, childs, id, config;
    ({device, childs, id, config} = this.$props);

    this.device = device;
    this.build(config);

    if (typeof childs === 'undefined') {
      childs = [];
      this.internal_config.childs = [];
    }

    if (typeof id !== 'undefined') {
      this.id = id;
    }

    let objIds = [];
    $('[id]').each(function () {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] === this && parseInt(this.id)) {
        objIds.push(this.id)
      }
    });

    if (objIds.includes(this.id)) {
      let newId = Date.now() + parseInt(Math.random() * 10000);
      this.id = newId;

      childs.forEach((el, index) => {
        try {
          childs[index].config.parent_id = newId;
        } catch (e) {
        }
      });

      this.$refs.elem.id = newId;
    }

    this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));

    let internalConfig = window.mergeRecursive(this.props, this.$props.config);
    this.internal_config = this.fixObjBackground({...internalConfig, ...this.internal_config});

    this.componentKey = '1';
  },

  mounted() {

    this.$root.$on('setConfigElement', (id, obj) => {
      if (+this.id === +id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.$root.$on('setChildsObj', (id) => {
      if (parseInt(this.id) === parseInt(id)) {
        this.setChildsObj();
      }
    });

    this.$root.$on('setChildsUndoRedo', (id, childs) => {
      if (+this.id === +id) {
        this.$eventHub.setChilds(this.id, childs);

        this.config.childs = childs;
        this.internal_config.childs = childs;

        this.elements = {};
        this.$nextTick(() => {
          this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
          this.componentKey += 1;
        });
      }
    });
  },
  updated() {
    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
    }
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

[element="BoxHoverComponent"] .vdr {
  min-height: 10px !important;
}

@media (max-width: 800px) {
  .sitebuilder-element-receiver {
    max-width: 220px;
    min-height: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/BoxHover/BoxHover.vue